/* eslint-disable no-unused-vars */
import { useState } from 'react';
import { fd, td } from '../theme';
import Ic from '../Icon';
import { printDocument, generateNoticeHTML } from './PDFExport';

const NOTICE_TYPES = ['30-Day Notice', '60-Day Notice', '90-Day Notice', 'Pay or Quit', 'Cure or Quit', 'Unconditional Quit'];
const REASONS      = ['Non-payment of rent', 'Lease violation', 'Property sale', 'Owner move-in', 'End of lease term', 'Other'];

export default function NoticeToVacate({ tenants = [], leases = [] }) {
  const [selTenant, setSelTenant] = useState('');
  const [form,      setForm]      = useState({ notice_type: '30-Day Notice', reason: 'Non-payment of rent', notes: '', delivery_date: td() });
  const [generated, setGenerated] = useState(false);

  const tenant = tenants.find(t => String(t.id) === String(selTenant));
  const lease  = tenant ? leases.find(l => (l.tenant_id || l.tid) === tenant.id) : null;

  const vacateDate = () => {
    if (!form.delivery_date) return '—';
    const d    = new Date(form.delivery_date);
    const days = parseInt(form.notice_type) || 30;
    d.setDate(d.getDate() + days);
    return fd(d.toISOString().split('T')[0]);
  };

  return (
    <div>
      <div className="card">
        <div className="card-hd"><h3>Notice to Vacate</h3></div>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(2,1fr)', gap:14 }}>
          <div className="fi fi-f" style={{ gridColumn:'1/-1' }}>
            <label>Tenant</label>
            <select value={selTenant} onChange={e => { setSelTenant(e.target.value); setGenerated(false); }}>
              <option value="">— Select tenant —</option>
              {tenants.map(t => <option key={t.id} value={t.id}>{t.full_name || t.name}</option>)}
            </select>
          </div>
          <div className="fi">
            <label>Notice Type</label>
            <select value={form.notice_type} onChange={e => setForm(p => ({...p, notice_type: e.target.value}))}>
              {NOTICE_TYPES.map(t => <option key={t}>{t}</option>)}
            </select>
          </div>
          <div className="fi">
            <label>Reason</label>
            <select value={form.reason} onChange={e => setForm(p => ({...p, reason: e.target.value}))}>
              {REASONS.map(r => <option key={r}>{r}</option>)}
            </select>
          </div>
          <div className="fi">
            <label>Delivery Date</label>
            <input type="date" value={form.delivery_date} onChange={e => setForm(p => ({...p, delivery_date: e.target.value}))}/>
          </div>
          <div className="fi fi-f">
            <label>Additional Notes (optional)</label>
            <input value={form.notes} onChange={e => setForm(p => ({...p, notes: e.target.value}))} placeholder="e.g. Balance owed: $1,650"/>
          </div>
        </div>
        <div style={{ display:'flex', justifyContent:'flex-end', gap:10, marginTop:14 }}>
          <button className="btn btn-g" onClick={() => setGenerated(true)} disabled={!selTenant}>
            <Ic n="doc" s={13}/> Generate Notice
          </button>
        </div>
      </div>

      {generated && tenant && (
        <div className="card" style={{ border:'1px solid rgba(248,81,73,.2)' }}>
          <div className="card-hd">
            <h3>Notice Preview</h3>
            <button className="btn btn-gh" onClick={() => printDocument(generateNoticeHTML(tenant, lease, form, vacateDate()))}>
              <Ic n="dl" s={13}/> Print / PDF
            </button>
          </div>
          <div style={{ background:'#21262d', borderRadius:10, padding:'24px 28px', lineHeight:1.8, color:'#f5f0e8' }}>
            <div style={{ textAlign:'center', marginBottom:24 }}>
              <div style={{ fontSize:11, color:'#8b949e', textTransform:'uppercase', letterSpacing:2 }}>Official Notice</div>
              <div style={{ fontFamily:"'Playfair Display',serif", fontSize:22, fontWeight:900, color:'#fff', marginTop:4 }}>{form.notice_type}</div>
            </div>
            <div style={{ borderBottom:'1px solid #30363d', paddingBottom:16, marginBottom:16, fontSize:13 }}>
              <div><strong>Date:</strong> {fd(form.delivery_date)}</div>
              <div><strong>Tenant:</strong> {tenant.full_name || tenant.name}</div>
              <div><strong>Property:</strong> {tenant.property || lease?.property || lease?.p || '—'}</div>
              <div><strong>Unit:</strong> {tenant.unit || tenant.u || lease?.unit || '—'}</div>
            </div>
            <div style={{ fontSize:13, marginBottom:16 }}>
              <p>
                This notice is to inform you that you are required to vacate the above-referenced premises
                by <strong style={{ color:'#f85149' }}>{vacateDate()}</strong>.
              </p>
              <p><strong>Reason:</strong> {form.reason}.</p>
              {form.notes && <p><strong>Notes:</strong> {form.notes}</p>}
              <p>
                If you fail to vacate the premises by the date stated above, legal proceedings to
                evict you from the premises may be taken against you.
              </p>
            </div>
            <div style={{ borderTop:'1px solid #30363d', paddingTop:16, fontSize:12, color:'#8b949e' }}>
              <div style={{ marginBottom:32 }}>Landlord Signature: _____________________________ &nbsp;&nbsp; Date: ____________</div>
              <div style={{ fontSize:11 }}>
                This notice was delivered on {fd(form.delivery_date)} and constitutes official notice under applicable state law.
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
